// IE 2026 10 24 / ODOO-348823 (форма записи каталога POLICY, поле «Settings schema (JSON)»): значение JSON-поля приходит либо объектом, либо СТРОКОЙ
// с JSON (так его кладёт посев, например '{\n "mode": {...}}'). Дерево строк AttrGrid обходило строку через for…in — по символам
// (строки `0 {`, `3 "`, `4 m`…). Эта функция приводит значение к виду { obj, text }: obj — разобранный объект/массив для дерева,
// text — строка для обычной текстовой строки (когда это не JSON или JSON не разбирается). Без Vue — чистая функция.

export function jsonFieldValue_parse(value) {
    if (value === null || value === undefined || value === '') return { obj: null, text: '' }
    if (typeof value === 'object') return { obj: value, text: '' }
    if (typeof value === 'string') {
        const head = value.trim().charAt(0)
        if (head === '{' || head === '[') {
            try {
                const parsed = JSON.parse(value)
                if (parsed !== null && typeof parsed === 'object') return { obj: parsed, text: '' }
            } catch (e) { /* не JSON — показываем как текст */ }
        }
        return { obj: null, text: value }
    }
    return { obj: null, text: String(value) }
}
